import React, { ChangeEvent } from 'react'
import { MenuItem, Select, InputLabel } from '@material-ui/core'
import FormControl, { FormControlProps } from '@material-ui/core/FormControl'
import { FieldNames, ISelectOption } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { dropdownOptions } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'

export interface IGenericDropdown {
  fieldName:
  | FieldNames.recurrenceMonth
  | FieldNames.recurrenceWeekday
  | FieldNames.recurrenceWeekdayCount
  | FieldNames.intradayRepeat
  | FieldNames.intradayRepeatInterval
  disabled?: boolean
  fieldLabel?: string
  margin?: FormControlProps['margin']
}

export const GenericDropdown = ({ fieldName, disabled = false, fieldLabel, margin = 'dense' }: IGenericDropdown) => {
  const [{ fieldValues }, dispatch] = usePublishSchedule()
  return (
    <FormControl margin={margin} className="generic-dropdown">
      {!!fieldLabel && (
        <InputLabel shrink id={`auto-${fieldLabel}-label`}>
          {fieldLabel}
        </InputLabel>
      )}
      <Select
        id={`auto-${fieldName}-dropdown-select`}
        className={disabled ? `auto-${fieldName}-disabled` : ''}
        disabled={disabled}
        onChange={
          ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
            dispatch(setFieldValue(fieldName, value))
          }
        }
        value={fieldValues[fieldName]}
      >
        {(dropdownOptions[fieldName] as Array<ISelectOption<any>>).map(({ value, label }) => (
          <MenuItem key={value} value={value}>{label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
